<template>
    <tr :class="[{'clickable': $_loggedUser_action_allowed('messages', 'read')}]" @click.stop="showMessageDetail(message.id_message)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="message.id"
                 :value="message.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="message.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td data-th="Název" class="first_data"><strong>{{ message.name }}</strong></td>
        <td data-th="Typ zprávy">{{ messageTypes[message.message_type] }}</td>
        <td data-th="Přečteno">
            <span class="dotted more_info_image" v-if="message.is_readed">
                <img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano">
                <span class="help_popup help_popup--no-wrap">
                    {{ $_datetime_format(message.timestamp_read) }}, {{ message.name_device_read }}
                </span>
            </span>
        </td>
        <td data-th="Smazáno">
            <span class="dotted more_info_image" v-if="message.is_deleted">
                <img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano">
                <span class="help_popup help_popup--no-wrap">
                    {{ $_datetime_format(message.timestamp_delete) }}, {{ message.name_device_delete }}
                </span>
            </span>
        </td>
        <td data-th="Vynucené potvrzení"><img v-if="message.forced_confirmation" class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"></td>
        <td data-th="Datum odeslání" class="last_data" v-html="$_date_formatFull(message.timestamp_created)" />
        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeleteMessage" :title="$gettext('Smazat')">{{ $gettext('Smazat') }}</a>
            </div>
        </td>
    </tr>
</template>

<script>
import links from "../../../mixins/links";

export default {
    name: "MessageRow",
    props: {
        message: Object,
        messageTypes: Object,
        selectedEntities: Array,
        isDeletable: Boolean
    },
    mixins: [links],
    methods: {
        onChange: function (e) {
          this.$emit('input', e)
        },
        onDeleteMessage() {
            this.$emit('deleteMessage', this.message.id);
        },
    },
    computed: {
      isChecked() {
        return this.selectedEntities.indexOf(String(this.message.id)) > -1
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/messages/MessageRow.vue